<template>
  <b-row>
    <b-col cols="12">
      <karma-request-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaRequestAddForm from './KarmaRequestAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaRequestAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
